import en from './en.json';
import it from './it.json';

export default {
    en,
    it,
};
